<template>
 <div>
    <div class="detailsTitle" >
       <h4>综合查询</h4>
       <!-- <div @click="back"><i class="fa fa-reply"></i></div> -->
    </div>
    <div class="searchBox" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="125px" size="mini">
        <div class="searchBox inpBox">
            <div class="gjhBox">
              <el-form-item label="捆包号:" prop="cargoBarcode"  label-width="90px">
                <el-input  placeholder=""  :rows="cargoBarRow" type="textarea" v-model="searchFrom.cargoBarcode" class="gjh"></el-input>
              </el-form-item>
            </div>
            <div class="item">
            <el-form-item label="货物状态:" prop="goodsStatus">
                <el-select placeholder="全部" v-model="searchFrom.goodsStatus">
                  <el-option  label="全部" value="" ></el-option>
                  <el-option  label="未装船" value="1" ></el-option>
                  <el-option  label="已装船" value="2" ></el-option>
                  <el-option  label="已卸船" value="3" ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="卸船类型:" prop="shipUnloadType">
              <el-select  v-model="searchFrom.shipUnloadType"   placeholder="全部">
                <el-option label="全部" value=""></el-option>
                <el-option label="自提" value="2"></el-option>
                <el-option label="入库" value="1"></el-option>
                <el-option label="过驳" value="3"></el-option>
              </el-select>
            </el-form-item>
              <el-form-item label="是否货损:" prop="isDamage">
                <el-select  v-model="searchFrom.isDamage"   placeholder="全部">
                  <el-option  label="全部" value="" ></el-option>
                  <el-option  label="是" value="1" ></el-option>
                  <el-option  label="否" value="2" ></el-option>
                </el-select>
              </el-form-item>
            <el-form-item label="查验状态:" prop="checkStatus">
              <el-select placeholder="全部" v-model="searchFrom.checkStatus">
                <el-option  label="全部" value="" ></el-option>
                <el-option  label="未查验" value="1" ></el-option>
                <el-option  label="已查验" value="2" ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="交货地址:" prop="consignAddressName">
              <el-input  placeholder="" v-model="searchFrom.consignAddressName"></el-input>
            </el-form-item>
            <el-form-item label="船运状态:" prop="shipStatus">
              <el-select v-model="searchFrom.shipStatus" placeholder="全部">
                <el-option v-for="val in shipStatus" :label="val.name" :value="val.id" :key="val.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="船运单号:" prop="shipTransportNo">
              <el-input  placeholder="" v-model="searchFrom.shipTransportNo"></el-input>
            </el-form-item>
            <el-form-item label="航次号:" prop="shipDateNo">
              <el-input  placeholder="" v-model="searchFrom.shipDateNo"></el-input>
            </el-form-item>
            <el-form-item label="船舶名称:" prop="shipName">
              <el-input placeholder="" v-model="searchFrom.shipName"></el-input>
            </el-form-item>
            <el-form-item label="客户名称:" prop="customerName">
              <el-input placeholder="" v-model="searchFrom.customerName"></el-input>
            </el-form-item>
            <el-form-item label="创建时间:" prop="relCreateTimes">
                <el-date-picker
                  v-model="searchFrom.relCreateTimes"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
            </el-form-item>
            </div>
        </div>

       <div class="searchBtnBox">
         <el-form-item>
            <el-button type="primary" @click="searchFn" v-if="btnFlg[0]">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="exportFn"  :disabled="isDisable" v-if="btnFlg[1]">导出</el-button>
          </el-form-item>
          <el-form-item>
           <p class="margin0" v-if="dataJson.allWeight">总重量：<span class="red">{{dataJson.allWeight}}</span>吨</p>
          </el-form-item>
          <el-form-item>
           <p class="margin0" v-if="dataJson.allNum">总件数：<span class="red">{{dataJson.allNum}}</span>件</p>
          </el-form-item>
       </div>
      </el-form>
    </div>
    <!-- 表格 -->
    <div :style="{height:h}">
       <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"
       @row-click="handleRowClick" class="table" height="100%" style="width: 100%" center   border>
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column fixed type="index"  width="55" label="序号"></el-table-column>
          <el-table-column label="操作" width="60">
            <template slot-scope="scope">
              <div>
                <el-button type="text" size="mini" v-if="scope.row.fileList.length>0&&btnFlg[2]" @click="lookFn(scope.row)">图片</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column property="cargoBarcode" width="240"  label="捆包号"></el-table-column>
          <el-table-column prop="shipTransportNo" width="240" :show-overflow-tooltip="true" label="船运单号"></el-table-column>
          <!-- <el-table-column property="shipDateFlag" width="120" label="运单标识" >
            <template scope="scope">
              {{[ "普通运单", "理货运单" ][scope.row.shipDateFlag-1]}}
            </template>
          </el-table-column> -->
          <el-table-column prop="belongCompany" width="240" :show-overflow-tooltip="true" label="隶属公司" :formatter="emptyFn" ></el-table-column>
          <el-table-column prop="shipStatus" label="船运状态" :formatter="CYstatusFormat" width="110"></el-table-column>
          <el-table-column prop="shipDateNo" width="200" :show-overflow-tooltip="true" label="航次号"></el-table-column>
          <el-table-column prop="shipName" width="160" :formatter="emptyFn" label="船舶名称"></el-table-column>
          <el-table-column prop="deliverAddressName" width="300" :formatter="emptyFn" label="起始港口"></el-table-column>
          <el-table-column property="receivingAddressName" :formatter="emptyFn" width="200" label="目的港口" show-overflow-tooltip></el-table-column>
          <el-table-column property="consignAddressName" :formatter="emptyFn" width="220" label="交货地址" show-overflow-tooltip></el-table-column>
          <el-table-column prop="customerName"  width="260" :formatter="emptyFn" label="客户名称"></el-table-column>
          <el-table-column property="productTypeName" :formatter="emptyFn" width="120" label="货物类型"></el-table-column>
          <el-table-column property="productName" :formatter="emptyFn" label="品名"></el-table-column>
          <el-table-column property="model" width="120" :formatter="emptyFn" label="材质"></el-table-column>
          <el-table-column property="specification" width="150" :formatter="emptyFn" label="规格"></el-table-column>
          <el-table-column property="weight" width="100" :formatter="emptyFn" label="重量(吨)"></el-table-column>
          <el-table-column prop="number" width="120" :formatter="emptyFn" label="件数(件)"></el-table-column>
          <el-table-column property="itemNo" width="120" :formatter="emptyFn" label="合同号"></el-table-column>
          <el-table-column property="contractNumber" :formatter="emptyFn" width="120" label="合约号"></el-table-column>
          <el-table-column property="sign" width="100" :formatter="emptyFn" label="标记"></el-table-column>
          <el-table-column prop="createUserName" width="200" :formatter="emptyFn"  label="创建人"></el-table-column>
          <el-table-column prop="relCreateTime" width="200" :formatter="dateTimeFormat"  label="创建时间"></el-table-column>
          <el-table-column prop="goodsStatus"  width="120" :formatter="statusFormat" label="货物状态"></el-table-column>
          <el-table-column prop="cargoBin" width="200" :show-overflow-tooltip="true" :formatter="emptyFn"  label="舱货位号">
            <template scope="scope">
              <div >
                {{scope.row.cargoHold}}-{{scope.row.cargoArea}}-{{scope.row.cargoFloor}}{{scope.row.cargoBin}}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="collectPerson" width="200" :show-overflow-tooltip="true" :formatter="emptyFn"  label="舱货位号采集人"></el-table-column>
          <el-table-column prop="collectTime" width="160" :formatter="dateTimeFormat"  label="舱货位号采集时间"></el-table-column>
          <el-table-column prop="collectType" width="200" :show-overflow-tooltip="true" :formatter="emptyFn"  label="舱货位采集方式"></el-table-column>
          <el-table-column property="status" width="130" label="卸船检查" >
            <template scope="scope">
              {{[ "未查验","已查验" ][scope.row.checkStatus-1]}}
            </template>
          </el-table-column>
          <el-table-column property="isDamage" label="是否货损"  min-width="130">
          <template scope="scope">
              <div>{{scope.row.isDamage=='1'?'是':'否'}}</div>
          </template>
        </el-table-column>
        <!-- <el-table-column property="shipUnloadType" label="卸船类型" min-width="130">
          <template scope="scope">
            <div v-if="scope.row.shipUnloadType">
             {{[ "入库", "自提" ][scope.row.shipUnloadType-1]}}
            </div>
            <div v-else>-</div>
          </template>
        </el-table-column> -->
        <el-table-column property="goodsStatus" label="卸船类型" >
          <template scope="scope">
            <div>
              <span>{{scope.row.shipUnloadType ? [ "入库", "自提", "过驳" ][scope.row.shipUnloadType-1] : '-'}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="carriageFleetName" :formatter="emptyFn" width="200" label="承运方" show-overflow-tooltip></el-table-column>
        <el-table-column property="shipUnloadRemark" :formatter="emptyFn" width="200" label="卸船备注" show-overflow-tooltip></el-table-column>
        <!-- <el-table-column property="warehouseAddressName" :formatter="emptyFn" width="200" label="入库地址" show-overflow-tooltip></el-table-column> -->
        <el-table-column property="shipUnloadUserName" :formatter="emptyFn" width="200" label="卸船理货人" show-overflow-tooltip></el-table-column>
        <el-table-column prop="shipUnloadTime" width="200" :formatter="dateTimeFormat"  label="卸船时间"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 查看 -->
    <el-dialog  title="查看"  :visible.sync="dialog" width="900px"  @close="closeDialog" :close-oni-click-modal="false" :close-on-press-escape="false" center>
    <div>
        <!-- <div class="addressBox" style="margin-bottom:20px" >
          <h4 class="title" >
            <span><i class="fa fa-bookmark-o iconFont" aria-hidden="true"></i>装船凭证</span>
          </h4>
           <div class="imgBox">
                <el-image
                 v-for="(item,index) in loadingImgs" :src="item" :key="index"
                  style="width: 260px; height: 200px"
                  :preview-src-list="getSrcList(index,loadingImgs)">
                </el-image>
            </div>
        </div> -->
         <div class="addressBox" >
          <h4 class="title" v-if="unloadImgs.length>0">
            <span><i class="fa fa-bookmark-o iconFont" aria-hidden="true"></i>卸船凭证</span>
          </h4>
           <div class="imgBox">
                <el-image
                 v-for="(item,index) in unloadImgs" :src="item" :key="index"
                  style="width: 260px; height: 200px"
                  :preview-src-list="getSrcList(index,unloadImgs)">
                </el-image>
            </div>
        </div>
    </div>
     <span slot="footer" class="dialog-footer">
        <el-button @click="dialog = false" type="primary">关 闭</el-button>
      </span>
   </el-dialog>
</div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { allList, dropDownList, sAddressList } from '@/api/shipping'
import { emptyFn, dateTimeFormat } from '@/utils/util'
import { exportExcel } from '@/utils/fileDown.js'
export default {
  data () {
    return {
      shipStatus: [
        { name: '全部', id: '' },
        { name: '已抵锚', id: 1101 },
        { name: '已起锚', id: 1102 },
        { name: '已封航', id: 1105 },
        { name: '已解封', id: 1106 },
        { name: '已靠泊', id: 1103 },
        { name: '已离泊', id: 1104 },
        { name: '装船完成', id: 1201 },
        { name: '卸船完成', id: 1202 }
      ],
      cargoBarRow: 4,
      isDisable: false,
      fileList: [],
      dialog: false,
      loadingImgs: [],
      unloadImgs: [],
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      h: '500px',
      weight: '0.00',
      tableList: [],
      loading: false,
      total: 0,
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      productTypes: [],
      MTList: [],
      dataJson: {},
      btnFlg: [],
      btnIdArr: ['00KM0A0100', '00KM0A0200', '00KM0A0300']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/overallSearch')
    this.getList(this.searchFrom)
    dropDownList().then(res => {
      this.productTypes = res
    })
    sAddressList({ addressType: 2 }).then(res => {
      this.MTList = res
    })
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    console.log(pH)
    if (pH > 900) {
      this.cargoBarRow = 2
    }
    this.h = (pH - h - 135) + 'px'
  },
  methods: {
    statusFormat (row, column, cellValue) {
      switch (cellValue) {
        case 1:
          return '未装船'
        case 2:
          return '已装船'
        case 3:
          return '已卸船'
      }
    },
    // 状态格式化
    CYstatusFormat (row, column, cellValue) {
      switch (cellValue) {
        case 1001:
          return '未开始'
        case 1101:
          return '已抵锚'
        case 1102:
          return '已起锚'
        case 1103:
          return '已靠泊'
        case 1104:
          return '已离泊'
        case 1105:
          return '已封航'
        case 1106:
          return '已解封'
        case 1201:
          return '装船完成'
        case 1202:
          return '卸船完成'
        case 1301:
          return '已完成'
      }
    },
    exportFn () {
      let form = { ...this.searchFrom }
      exportExcel(
        this.global.shipping + '/sBusinessGoodsRel/exportAllList',
        form,
        '综合查询列表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 点击图片放大
    getSrcList (index, arr) {
      return arr.slice(index).concat(arr.slice(0, index))
    },
    // 查看
    lookFn (row) {
      this.fileList = row.fileList
      this.dialog = true
      this.loadingImgs = []
      this.unloadImgs = []
      this.fileList.forEach(item => {
        if (item.type == 1) {
          this.loadingImgs.push(item.fileUrlOSS)
        }
        if (item.type == 2) {
          this.unloadImgs.push(item.fileUrlOSS)
        }
      })
    },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcode) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcode.split(/[(\r\n)\r\n]+/) } else {
        this.searchFrom.cargoBarcodes = ''
      }

      this.getList(this.searchFrom)
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      allList(searchFrom).then(res => {
        this.loading = false
        this.dataJson.allNum = res.allNum
        this.dataJson.allWeight = res.allWeight
        this.tableList = res.pageInfo.list
        this.total = res.pageInfo.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    closeDialog () {
    },
    // back () {
    //   this.$router.go(-1)// 返回上一层
    // },
    // 重置
    resetForm (formName) {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        createTime: null
      }
    }

  }
}
</script>

<style scoped  lang='less'>
.searchBox{
  display: flex;
  .inpBox .el-date-editor{
      width: 350px!important;
  }
}
/deep/.autoBox .el-form-item__content{
  width:150px;
}
/deep/ .gjhBox{
  width: 268px;
/deep/ .el-form-item__label{
       width: 60px!important;
    flex-shrink: 0;
 }
 /deep/.el-form-item__content{
   flex-shrink: 0;
    width: 150px;
 }
}
.addgood{
  /deep/.el-form-item__content{
    width: 193px;
  }
}
</style>
